import { combineReducers } from "redux";
import Auth from "./Auth";

// import Theme from './Theme';
import Organization from "./Organization";
import Bot from "./Bot";
import UsersAndTeam from "./UsersAndTeam";
import channel from "./channel";
import common from "./common";
import inbox from "./inbox";
import campaign from "./Campaign";
import contacts from "./Contacts";
import botFlow from "./BotFlow";
import botVars from "./BotVars";
import faas from "./Faas";
import dashboard from "./dashboard";
import chatAssignment from "./ChatAssignment";
import Schedule from "./Schedule";
import emailAssignment from "./EmailAssignment";
import tickets from "./tickets";
import payWall from "./PayWall";
import marketPlace from "./MarketPlace";

const reducers = combineReducers({
  auth: Auth,
  organization: Organization,
  bot: Bot,
  UsersAndTeam,
  channel,
  common,
  inbox,
  campaign,
  contacts,
  botFlow,
  botVars,
  faas,
  dashboard,
  chatAssignment,
  Schedule,
  emailAssignment,
  tickets,
  payWall,
  marketPlace,
});

export default reducers;
